import React from 'react'
import styled from '@emotion/styled'
import { Form } from 'stylist'
import size from 'lodash/size'
import entries from 'lodash/entries'
import sortBy from 'lodash/sortBy'
import { getLocales } from 'utils/api'

const Wrapper = styled.div`
  width: 225px;
`

class EstimateLocale extends React.Component {
  state = {
    locales: {}
  }

  constructor(props) {
    super(props)
    getLocales().then(resp => this.setState({ locales: resp.data }))
  }

  render() {
    return (
      <Wrapper id="locale">
        {size(this.state.locales) ? (
          <Form.Select name="locale">
            {sortBy(
              entries(this.state.locales),
              ([_, { country }]) => country
            ).map(([locale, { lang, country }]) => (
              <Form.Select.Option value={locale} key={locale}>
                {country} - {lang}
              </Form.Select.Option>
            ))}
          </Form.Select>
        ) : null}
      </Wrapper>
    )
  }
}

export default EstimateLocale



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/EstimateLocale.js